export type JobName =
  | 'PricingSync'
  | 'ProductSync'
  | 'ProductImport'
  | 'HylaOracleInventorySync'
  | 'AIZOracleInventorySync'
  | 'SalesChannelInventorySync'
  | 'BuyerImport'
  | 'BuyerAddressImport'
  | 'BuyerLoginImport';

export const JobMap: Record<JobName, string> = {
  PricingSync: 'MongoDB Data Sync-pricing',
  ProductSync: 'MongoDB Data Sync-product',
  ProductImport: 'Generic File Import - Product',
  HylaOracleInventorySync: 'Hyla Oracle Inventory Import',
  AIZOracleInventorySync: 'Aiz Oracle Inventory Import',
  SalesChannelInventorySync: 'Sales Channel Inventory Sync',
  BuyerImport: 'Generic File Import - Buyer',
  BuyerAddressImport: 'Generic File Import - BuyerAddress',
  BuyerLoginImport: 'Generic File Import - BuyerLogin',
};
